module.exports = __webpack_public_path__ + "img/check3-null.437be3c7.svg";